import React, { useState, useEffect } from "react";
import { ReactSVG } from "react-svg";
import ticket_two from "../../assets/svg/ticket_two.svg";
import ticketSingle from "../../assets/svg/ticket_single.svg";
import { getticketsbyid } from "../../fetch/api/ticketCard";
import { Spin, message as AndMessage } from "antd";

const PurchasedModal = ({ toggleModal, product_id }) => {
  const [loading, setLoading] = useState(true);
  const [add_num, setadd_num] = useState("");
  const [u_coin, setu_coin] = useState("");
  const obtainUrl = () => {
    let urlArr;
    let urlData = decodeURIComponent(window.location.search);
    let temp = urlData.replace("?", "");
    urlArr = temp.split("&");
    let URLdata = {};
    let temp1 = [];
    for (let i = 0; i < urlArr.length; i++) {
      temp1 = urlArr[i].split("=");
      URLdata[temp1[0]] = temp1[1];
    }
    temp1 = [];
    return URLdata;
  };
  useEffect(() => {
    let login = JSON.parse(localStorage.getItem("login"));
    if (login) {
      getticketsbyid({ product_id: obtainUrl().product_id }).then((res) => {
        setLoading(false);
        if (res) {
          const { code, data, message } = res;
          if (code == 200) {
            setadd_num(data.add_num);
            setu_coin(data.u_coin);
            login.u_coin = data.u_coin;
            localStorage.setItem("login", JSON.stringify(login));
          } else {
            AndMessage.error({
              content: message,
              maxCount: 1,
            });
          }
        }
      });
    }
  }, []);
  return (
    <div className="fixed z-50 w-full overflow-x-hidden overflow-y-auto md:inset-0 h-[100%] max-h-full bg-[rgba(0, 0, 0, 0.61)] backdrop-blur-[7px] inset-0 ">
      <div className="relative w-full h-full flex items-center justify-center">
        {/* <!-- Modal content --> */}
        <div className=" bg-stadeo-bold-green rounded-[10px] shadow w-[317px] h-[417px] m-auto flex flex-col ">
          {/* <!-- Modal body --> */}
          <div className="w-full h-full">
            <Spin spinning={loading}>
              <div className="w-[100%] h-[100%] flex flex-col items-center relative">
                <div
                  className="absolute right-[11px] top-[11px] text-white text-sm cursor-pointer"
                  onClick={toggleModal}
                >
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </div>
                <div className="w-[87px] h-[66px] mt-[29px]">
                  <ReactSVG className="ReactSVG" src={ticket_two} />
                </div>
                <div className="mt-[7px] text-white text-[23px] font-bold">
                  +{add_num}
                </div>
                <div className="mt-[15px] text-white text-[12px] font-bold font-monumentextended">
                  Tickets purchased!
                </div>
                <div className=" bg-white mr-[26px] h-[37px] pl-[36px] pr-[19px] flex items-center text-[18px] font-medium relative rounded-[75px] rounded-bl-[225px] mt-[51px]">
                  <div className=" absolute left-[-15px] w-[33px] h-[25px]">
                    <ReactSVG className="ReactSVG " src={ticketSingle} />
                  </div>
                  <span className="z-[1] min-w-[56px]">{u_coin}</span>
                </div>
                <div
                  className="rounded-[75px] bg-white w-[261px] h-[51px] text-[16px] flex items-center justify-center show border-[2px] border-[#09B251] mt-[80px] cursor-pointer text-[#09B251] font-semibold"
                  style={{ boxShadow: "0px 11px 15px rgba(0, 0, 0, 0.15)" }}
                  onClick={toggleModal}
                >
                  CLOSE
                </div>
              </div>
            </Spin>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchasedModal;
